// extracted by mini-css-extract-plugin
module.exports = {"watch":"watch_watch__1yu19","video__container":"watch_video__container__13oE-","watch__list":"watch_watch__list__3FavC"};